const t=({palette:r,vars:e})=>({styleOverrides:{root:{border:`solid 1px ${((e==null?void 0:e.palette)||r).divider}`,borderRadius:4}}});export{t as default};
